import cn from 'classnames';
import { ColumnProps } from 'antd/lib/table';
import { Icon, Tag } from 'Components';
import { OverviewGroupSummary } from 'Services/Api/Dashboard/Types';
import styles from './GroupSummaryTable.module.scss';
import { STATUS_COLOR } from 'Pages/Dashboard/Dashboard.constants';

const sortableTitle = (label: string) => (
	<span className={styles.colTitle}>
		<span>{label}</span>
		<Icon
			type="chevronDown"
			className={`${styles.colSortIcon} group-table-sort-icon`}
		/>
	</span>
);

export const renderScoreCell = (value: number | undefined | null) => {
	if (value == null) return '—';
	const isGood = value >= 50;
	return (
		<span className={styles.scoreCell}>
			<span
				className={cn(
					styles.dot,
					isGood ? styles.dotBlue : styles.dotOrange
				)}
			/>
			{`${Math.round(value)}%`}
		</span>
	);
};

export const renderTagCell = (value: string | undefined) => {
	if (!value) return '---';
	const tag = value === "pass" ? "Compliant" : value === "fail" ? "Non-Compliant" : value === "incomplete" ? "Incomplete" : "Not Started";
	const { color, background } = STATUS_COLOR[tag] || STATUS_COLOR["Not Started"];

	return <Tag style={{ background, color }}>{tag || ""}</Tag>
};

export function getGroupSummaryColumns(): ColumnProps<OverviewGroupSummary>[] {
	return [
		{
			title: sortableTitle('Summary'),
			key: 'groupName',
			dataIndex: 'groupName',
			sorter: true
		},
		{
			title: sortableTitle('Phishing'),
			key: 'phishingScore',
			dataIndex: 'phishingScore',
			render: renderScoreCell,
			sorter: true
		},
		{
			title: sortableTitle('Training'),
			key: 'elearningScore',
			dataIndex: 'elearningScore',
			render: renderScoreCell,
			sorter: true
		},
		{
			title: "SAQ Compliance",
			key: 'saqStatus',
			dataIndex: 'saqStatus',
			align: "center",
			render: renderTagCell
		},
		{
			title: "Scanning",
			key: 'scanningStatus',
			dataIndex: 'scanningStatus',
			align: "center",
			render: renderTagCell
		}
	];
}
